var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFormIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2495 12.749V4.43652L7.31201 0.499023H2.49951C2.03538 0.499023 1.59026 0.683398 1.26207 1.01159C0.933886 1.33978 0.749512 1.78489 0.749512 2.24902V12.749C0.749512 13.2132 0.933886 13.6583 1.26207 13.9865C1.59026 14.3146 2.03538 14.499 2.49951 14.499H9.49951C9.96364 14.499 10.4088 14.3146 10.7369 13.9865C11.0651 13.6583 11.2495 13.2132 11.2495 12.749ZM7.31201 3.12402C7.31201 3.47212 7.45029 3.80596 7.69643 4.0521C7.94258 4.29824 8.27641 4.43652 8.62451 4.43652H10.3745V8.37402H1.62451V2.24902C1.62451 2.01696 1.7167 1.7944 1.88079 1.6303C2.04489 1.46621 2.26745 1.37402 2.49951 1.37402H7.31201V3.12402ZM1.62451 10.999V9.24902H3.37451V10.999H1.62451ZM1.62451 11.874H3.37451V13.624H2.49951C2.26745 13.624 2.04489 13.5318 1.88079 13.3677C1.7167 13.2036 1.62451 12.9811 1.62451 12.749V11.874ZM4.24951 13.624V11.874H10.3745V12.749C10.3745 12.9811 10.2823 13.2036 10.1182 13.3677C9.95414 13.5318 9.73158 13.624 9.49951 13.624H4.24951ZM10.3745 10.999H4.24951V9.24902H10.3745V10.999Z",
    fill: "#212529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormIcon);
export default __webpack_public_path__ + "static/media/form_icon.d6c7fd3ef6e5e90cb8136d1c9bde760a.svg";
export { ForwardRef as ReactComponent };